/**
 *
 *  With Availability
 *  HOC Component
 *
 *  Handles all of the logic with availability


  time, provide with min/max times and time slots
 *  Initialises booking time from start_time query string.
 *  startTimes should be in mapStateToProps param to calculate timeSlots and availableDays
 *
 *  Created by Vladimir Shislyannikov on 14/11/2019.
 *  Copyright (c) 2021 iWoo Ltd. All rights reserved.
 *
 */

import React, { useState, useEffect, useCallback, useRef } from 'react';
import // Text,
// View,
// StyleSheet,
// TextStyle,
// ViewStyle,
// Dimensions,
// Animated
'react-native';
// import ReactDOM from 'react-dom';
// import createReactClass from 'create-react-class';
// import PropTypes from 'prop-types'; // use directly
// import hoistNonReactStatic from 'hoist-non-react-statics';
// import { withRouter } from 'react-router';
// import { connect } from 'react-redux';
// import compose from 'recompose/compose';
// import { updateBookingDateTime } from 'mainApp/actions/ui';
// import _ from 'mainApp/utils/_';
// import { getMoment, extractTimeSlotsForDate, inRangeTime, } from 'mainApp/utils/date';
// import { LOCATION_TYPES } from 'mainApp/constants';

// import BookingTime from 'mainApp/BookingTime';

// import clsx from 'clsx';
// const Calendar = require('./Calendar');
// const TimeList = require('./TimeList');
// import Drawer from '@material-ui/core/Drawer';
// import Box from '@material-ui/core/Box';

// import Typography from '@material-ui/core/Typography';

// import CloseIcon from '../../icons/Close2Icon';

import { makeStyles, Theme } from '@material-ui/core/styles';

import SlidingUpPanel from 'rn-sliding-up-panel';
import { Drawer as TruBeDrawer } from '../Drawer/Drawer';

// import Header from './Header/Header';
// import Month from './Month/Month';
import AvailabilityDayPickerView from './AvailabilityDayPicker/AvailabilityDayPicker';
import AvailabilityTimePickerView from './AvailabilityTimePicker/AvailabilityTimePicker';
import SetEveryWeekdayDialog from '../SetEveryWeekdayDialog/SetEveryWeekdayDialog';
import ClearAllTimeSlotsDialog from '../ClearAllTimeSlotsDialog/ClearAllTimeSlotsDialog';

import moment from 'moment-timezone';

import { Availability, DayAvailability, TimeSlot, AvailabilityViewTimeSlot } from '../../types';
import * as dates from '../../utils/dates';
import { getMomentWithTz } from '../../utils/date';
// import { getViewportHeight } from '../../utils';
import { date as dateLocalizer } from '../../utils/localizers';

import { useAppState } from '../../state';

const useStyles = makeStyles((theme: Theme) => ({
  apCalendar: {
    outline: 'none',
  },
}));

// const styles = {
//   container: {
//     flex: 1,
//     'background-color': theme.greyLight,
//     'align-items': 'center',
//     'justify-content': 'center',
//     'border-radius': '8px',
//     height: '100%',
//   },
//   closeAvailabilityTimePickerPanel: {
//     cursor: 'pointer',
//     display: 'flex',
//     background: 'transparent',
//     border: '0',
//     padding: '0',
//     color: '#E94E32',
//   },
//   apCalendar: {
//     outline: 'none',
//   }
// };

// type PanelStyle = {
//   backdrop: ViewStyle;
//   container: ViewStyle;
//   // title: TextStyle;
//   // icon: ImageStyle;
// };

// const panelStyles = StyleSheet.create<PanelStyle>({
//   backdrop: {
//     // position: 'fixed',
//     position: 'absolute',
//     'z-index': 1000,
//   },
//   container: {
//     // position: 'fixed',
//     position: 'absolute',
//     'z-index': 1000,
//   },
// });

// const panelStyles = {
//   backdrop: {
//       position: 'fixed',
//       'z-index': 1000,
//   },
//   container: {
//     position: 'fixed',
//     // flex: 1,
//     // 'background-color': 'rgb(255, 255, 255)',
//     // 'align-items': 'center',
//     // 'justify-content': 'center',
//     'z-index': 1000,
//   },
// };

// const height = getViewportHeight();

// ignoreStartTimeQueryParam - controls whether the WrappedComponent depends on
// start_time query param or it should not rely on it
// Potential bug: when one component depends setting date on this param,
// while the others don't
// export default function AvailabilityPicker(mapStateToProps: object, ignoreStartTimeQueryParam: boolean) {
export default function AvailabilityPicker(props: {
  disabled?: boolean;
  className?: string;
  readOnly?: boolean;
  focused?: boolean;
  culture?: string;
  region?: string;
  activeId?: string;
  tabIndex?: number;
  // currentDate?: Date;
  value?: Date;
  // views?: any;
  min?: Date;
  max?: Date;
  step?: number;
  dayComponent?: any;
  dayFormat?: string;
  dateFormat?: string;
  /**
   * A formatter for the header button of the month view.
   *
   * @example ['dateFormat', ['headerFormat', "{ date: 'medium' }"]]
   */
  headerFormat?: string; //PropTypes.string,

  // onCurrentDateChange?: (date: Date) => void;
  onCurrentDayChange?: (date: Date) => void;
  onChange?: (date: Date) => void;
}) {
  const {
    // currentDate,
    // className,
    // value,
    // disabled,
    // readOnly,
    // views,
    // min,
    // max,
    // step,
    headerFormat,
    culture,
    region,
    tabIndex,
    onCurrentDayChange,
  } = props;

  const classes = useStyles();

  const {
    isFetching,
    isAvailabilityFetching,
    isAvailabilityLoading,
    user,
    dayAvailability,
    setDayAvailability,
    bookedTimeSlots,
    getAvailability,
    getBookedTimeSlots,
    updateAvailability,
  } = useAppState();

  // const [focused, setFocused] = useState(false);
  const [todaysDate] = useState<Date>(getMomentWithTz(new Date(), region!).toDate());
  const [minDate, setMinDate] = useState<moment.Moment | null>(null);
  const [maxDate, setMaxDate] = useState<moment.Moment | null>(null);

  // const [ _currentDate, _setCurrentDate ] = useState(false);

  const [selectedDay, setSelectedDay] = useState<Date | null>(null);
  const [title, setTitle] = useState<string>('');
  const [weekDayLabel, setWeekDayLabel] = useState<string>('');
  const [monthLabel, setMonthLabel] = useState<string>('');
  // const [dayAvailabilityWeekly, setDayAvailabilityWeekly] = useState<DayAvailability[]>([]);
  const [times, setTimes] = useState<AvailabilityViewTimeSlot[]>([]);
  // const [times, setTimes] = useState<{ date: Date, disabled: boolean, slotType: string, label: string }[]>([]);
  const [timesHash, setTimesHash] = useState<number | null>(null);
  // const [timeSlots, setTimeSlots] = useState<TimeSlot[] | undefined>([]);
  const [isAllDay, setIsAllDay] = useState(false);
  const [, setBookingHours] = useState(0);
  const [isWeekly, setIsWeekly] = useState<boolean>(false);
  const [clearAll, setClearAll] = useState<boolean>(false);
  const [isSetEveryWeekdayDialogOpen, setIsSetEveryWeekdayDialogOpen] = useState<boolean>(false);
  const [clearAllTimeSlotsDialogOpen, setClearAllTimeSlotsDialogOpen] = useState<boolean>(false);

  // const [ _highlightedDays, _setHighlightedDays ] = useState<number[]>([]);
  // const [ _hasBookingsDays, _setHasBookingsDays ] = useState<number[]>([]);

  const [availabilityTimePickerDrawerOpen, setAvailabilityTimePickerDrawerOpen] = useState<boolean>(false);

  // const [ dayAvailability, setDayAvailability ] = useState<DayAvailability[]>([]);

  // const panelRef = useRef<SlidingUpPanel>(null);
  const panelRef = useRef<SlidingUpPanel>(null);
  const timeSlotsRef = useRef<TimeSlot[]>([]);
  const bookedTimeSlotsRef = useRef<Availability>(null);

  useEffect(() => {
    getAvailability(user?.id!);
    getBookedTimeSlots(user?.id!);

    const min = getMomentWithTz(new Date(), region!).startOf('month');
    const max = min.clone().add(3, 'month');

    setMinDate(min);
    setMaxDate(max);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user /*, getAvailability -- do not enable, otherwise circular calls */]);

  useEffect(() => {
    if (selectedDay) {
      setTitle(getMomentWithTz(selectedDay, region!).format('DD MMMM'));
    }
  }, [selectedDay, culture]);
  // console.log('dayAvailability', dayAvailability);

  // const getCurrentDate = (): Date => props.currentDate || value || new Date();

  const getHeaderLabel = useCallback(
    (date: Date): string => {
      // let { headerFormat = props; //,
      // currentDate = getCurrentDate();

      // headerFormat = headerFormat || 'MMMM YYYY';

      // if (['LEFT', 'RIGHT'].indexOf(direction) !== -1) {
      //     let method = direction === 'LEFT' ? 'subtract' : 'add';

      //     return dateLocalizer.format(dates[method](this.getCurrentDate(), 1, this.state.view), headerFormat, culture);
      // }

      return getMomentWithTz(date, region!).format(
        /*currentDate*/
        dateLocalizer.getFormat('header', headerFormat || 'dddd')
        // culture
      );
    },
    [headerFormat, region, culture]
  );

  const inRangeValue = useCallback(
    (_value: any) => {
      let value = dateOrNull(_value);

      if (value === null) {
        return value;
      }

      // return dates.max(
      //   dates.min(value, max),
      //   min
      // );
      return dates.max(dates.min(value, maxDate), minDate);
    },
    [minDate, maxDate]
  );

  const allDaySelected = (): boolean => !timeSlotsRef.current.some(ts => ts.slotType === 'UNAVAILABLE');

  // const getHeaderLabel = (): string => {
  //   // let { selectedDay, culture, headerFormat } = this.props;

  //   headerFormat = dateLocalizer.getFormat('header', 'dddd'/*headerFormat*/);
  //       // headerFormat = headerFormat || 'MMMM YYYY';

  //       // if (['LEFT', 'RIGHT'].indexOf(direction) !== -1) {
  //       //     let method = direction === 'LEFT' ? 'subtract' : 'add';

  //       //     return dateLocalizer.format(dates[method](this.getCurrentDate(), 1, this.state.view), headerFormat, culture);
  //       // }

  //   return dateLocalizer.format(selectedDay /*currentDate*/, headerFormat, culture);
  // };

  const setCurrentDate = useCallback(
    (date: Date /*, currentDate: Date = getCurrentDate()*/) => {
      const inRangeDate = inRangeValue(date); // ? new Date(date) : currentDate);

      setSelectedDay(inRangeDate);

      // if (dates.eq(inRangeDate, dateOrNull(currentDate), 'month')) {
      //     return;
      // }

      // _setCurrentDate(inRangeDate);

      // notify(this.props.onCurrentDateChange, inRangeDate);
      onCurrentDayChange && onCurrentDayChange(inRangeDate);
    },
    [onCurrentDayChange, inRangeValue]
  );

  // Populating time slots for displaying. Only selected or booked presented.
  // All operations in local time zone
  const populateTimeSlots = useCallback((): TimeSlot[] => {
    // const { selectedDay, culture } = this.props;

    const newTimeSlots: TimeSlot[] = [];

    if (!selectedDay) {
      return [];
    }

    // const tsFormat = dateLocalizer.getFormat('header', 'YYYY-MM-DD'/*headerFormat*/);
    const dateStr = dateLocalizer.format(selectedDay, 'YYYY-MM-DD', culture);

    const partnerAvailability = dayAvailability!.content!;

    Object.keys(bookedTimeSlots!).forEach(key => {
      // @ts-ignore
      const bookedTimeSlotStart = getMomentWithTz(key, region);

      if (!bookedTimeSlotStart.isSame(selectedDay, 'day')) {
        return;
      }

      // let lowDate = bookedTimeSlotStart
      //   .clone()
      //   .startOf('day')
      //   .add(330, 'minutes');
      // let highDate = bookedTimeSlotStart
      //   .clone()
      //   .endOf('day')
      //   .add(-30, 'minutes');

      // let bookedTimeSlotDateMinusHalfAnHour = bookedTimeSlotStart.clone().subtract(30, 'minutes');
      // let bookedTimeSlotDateMinusHour = bookedTimeSlotStart.clone().subtract(60, 'minutes');
      // let bookedTimeSlotDatePlusHalfAnHour = bookedTimeSlotStart.clone().add(30, 'minutes');
      // let bookedTimeSlotDatePlusHour = bookedTimeSlotStart.clone().add(60, 'minutes');

      // if (
      //   bookedTimeSlotDateMinusHalfAnHour.isSameOrAfter(lowDate) &&
      //   bookedTimeSlotDateMinusHalfAnHour.isSameOrBefore(highDate)
      // ) {
      //   newTimeSlots.push({
      //     slotType: 'IS_NOT_AVAILABLE_FOR_BOOKING',
      //     startTime: bookedTimeSlotDateMinusHalfAnHour.format('HH:mm'),
      //     start: bookedTimeSlotDateMinusHalfAnHour.toDate(),
      //     end: bookedTimeSlotDateMinusHalfAnHour
      //       .clone()
      //       .add(30, 'minutes')
      //       .toDate(),
      //     endTime: bookedTimeSlotDateMinusHalfAnHour.format('HH:mm'),
      //   });

      //   delete partnerAvailability[bookedTimeSlotDateMinusHalfAnHour.toISOString()];
      // }

      // if (bookedTimeSlotDateMinusHour.isSameOrAfter(lowDate) && bookedTimeSlotDateMinusHour.isSameOrBefore(highDate)) {
      //   newTimeSlots.push({
      //     slotType: 'IS_NOT_AVAILABLE_FOR_BOOKING',
      //     startTime: bookedTimeSlotDateMinusHour.format('HH:mm'),
      //     start: bookedTimeSlotDateMinusHour.toDate(),
      //     end: bookedTimeSlotDateMinusHour
      //       .clone()
      //       .add(30, 'minutes')
      //       .toDate(),
      //     endTime: bookedTimeSlotDateMinusHour.format('HH:mm'),
      //   });

      //   delete partnerAvailability[bookedTimeSlotDateMinusHour.toISOString()];
      // }

      newTimeSlots.push({
        slotType: 'IS_NOT_AVAILABLE_FOR_BOOKING', // 'IN_SESSION',
        startTime: bookedTimeSlotStart.format('HH:mm'),
        startTimeWithAmPm: bookedTimeSlotStart.format('h:mm A'),
        start: bookedTimeSlotStart.toDate(),
        end: bookedTimeSlotStart
          .clone()
          .add(30, 'minutes')
          .toDate(),
        endTime: bookedTimeSlotStart.format('HH:mm'),
      });

      delete partnerAvailability[bookedTimeSlotStart.toISOString()];

      // if (
      //   bookedTimeSlotDatePlusHalfAnHour.isSameOrAfter(lowDate) &&
      //   bookedTimeSlotDatePlusHalfAnHour.isSameOrBefore(highDate)
      // ) {
      //   newTimeSlots.push({
      //     slotType: 'IS_NOT_AVAILABLE_FOR_BOOKING',
      //     startTime: bookedTimeSlotDatePlusHalfAnHour.format('HH:mm'),
      //     start: bookedTimeSlotDatePlusHalfAnHour.toDate(),
      //     end: bookedTimeSlotDatePlusHalfAnHour
      //       .clone()
      //       .add(30, 'minutes')
      //       .toDate(),
      //     endTime: bookedTimeSlotDatePlusHalfAnHour.format('HH:mm'),
      //   });

      //   delete partnerAvailability[bookedTimeSlotDatePlusHalfAnHour.toISOString()];
      // }

      // if (bookedTimeSlotDatePlusHour.isSameOrAfter(lowDate) && bookedTimeSlotDatePlusHour.isSameOrBefore(highDate)) {
      //   newTimeSlots.push({
      //     slotType: 'IS_NOT_AVAILABLE_FOR_BOOKING',
      //     startTime: bookedTimeSlotDatePlusHour.format('HH:mm'),
      //     start: bookedTimeSlotDatePlusHour.toDate(),
      //     end: bookedTimeSlotDatePlusHour
      //       .clone()
      //       .add(30, 'minutes')
      //       .toDate(),
      //     endTime: bookedTimeSlotDatePlusHour.format('HH:mm'),
      //   });

      //   delete partnerAvailability[bookedTimeSlotDatePlusHour.toISOString()];
      // }
    });

    Object.keys(partnerAvailability).forEach((val: string) => {
      // val.//forEach(e => acc += (acc ? '&': '') + key + '=' + e);

      // headerFormat = headerFormat || 'MMMM YYYY';

      // if (['LEFT', 'RIGHT'].indexOf(direction) !== -1) {
      //     let method = direction === 'LEFT' ? 'subtract' : 'add';

      //     return dateLocalizer.format(dates[method](this.getCurrentDate(), 1, this.state.view), headerFormat, culture);
      // }

      // const selectedDay = dates.date(this.props.selectedDay);
      // const selectedMonth = dates.month(this.props.selectedDay);
      // const selectedYear = dates.year(this.props.selectedDay);

      const newDate = getMomentWithTz(val, region!); //.local();

      if (newDate.format('YYYY-MM-DD') === dateStr) {
        let endTime = newDate.clone().add(30, 'minutes');

        // let bookedTimeSlot = bookedTimeSlots && bookedTimeSlots[val]; // bookedTimeSlots?.find(ts => ts.start === val.start);

        // Can't do as available
        if (!newTimeSlots.find(val => val.startTime === newDate.format('HH:mm'))) {
          newTimeSlots.push({
            slotType: 'AVAILABLE',
            startTime: newDate.format('HH:mm'),
            startTimeWithAmPm: newDate.format('h:mm A'),
            start: newDate.toDate(),
            end: endTime.toDate(),
            endTime: endTime.format('HH:mm' /*, culture*/),
          });
        }
      }
      //      = val.timeSlots.map((ts: TimeSlot) => {
      //     const { startTime, endTime } = ts;
      //     const [startHours, startMinutes] = startTime.split(':')
      //     // @ts-ignore
      //     const [endHours, endMinutes] = endTime.split(':')

      //     let start = dates.startOf(selectedDay);

      //     start = dates.hours(start, Number(startHours));
      //     start = dates.minutes(start, Number(startMinutes));

      //     let end = dates.startOf(selectedDay);

      //     end = dates.hours(end, Number(endHours));
      //     end = dates.minutes(end, Number(endMinutes));

      //     return {
      //       ...ts,
      //       start,
      //       end,
      //     }
      //   });
      // }
    });

    return newTimeSlots;
  }, [selectedDay, dayAvailability, bookedTimeSlots, region, culture]);

  // Generate times to display in Availability Day Picker and applying time slots
  // if passed.
  const getTimes = useCallback(
    (timeSlots?: TimeSlot[], allDaySelected?: boolean): AvailabilityViewTimeSlot[] => {
      var newTimes: AvailabilityViewTimeSlot[] = [];
      // var value = this.props.value || this.props.currentDate || dates.today();
      // var values = this.getBounds(this.props);
      // var minTime = this.props.minTime;
      // var timezoneOffset = values.min.getTimezoneOffset();
      // var start = values.min; // dates.add(values.min, timezoneOffset, 'minutes'); // Normalize min time according to the time zone
      // const selectedDay = this.props.selectedDay;

      // @ts-ignore
      var start = getMomentWithTz(selectedDay, region).startOf('day');
      // @ts-ignore
      var startDay = getMomentWithTz(selectedDay, region).date(); // get day

      start.add(330, 'minutes');

      // console.log('AvailabilityTimePickerView getTimes');

      while (
        start.date() === startDay &&
        start.isSameOrBefore(
          start
            .clone()
            .endOf('day')
            .add(-30 /* 23 hr is the max available time */, 'minutes')
        )
      ) {
        let found = null;
        let disabled = false;

        const startMinutes = start.minutes();
        const startHours = start.hours();
        // const startLabel = `${startHours < 10 ? '0' : ''}${startHours}:${
        //   startMinutes !== 30 ? '0' : ''
        // }${startMinutes}`;
        const startLabel = start.format('h:mm');

        if (!timeSlots || !timeSlots.length) {
          disabled = true;
        } else {
          // We check only hours and then merge date and time in DateTimePicker
          found = timeSlots.find((slot: TimeSlot) => {
            return start.isSame(slot.start); //startLabel === slot.startTime; // startHours === dates.hours(slot.start) && startMinutes === dates.minutes(slot.start);
          });

          disabled = !found && allDaySelected === undefined;
        }

        // let noon = dates.add(dates.startOf(start, 'day'), 810, 'minutes'); // 13:30
        // let evening = dates.add(dates.startOf(start, 'day'), 1110, 'minutes'); // 18:30

        // if (this.checkTimeZoneShift(start, values.min, values.max, timezoneOffset)) {
        newTimes.push({
          date: start.toDate(),
          disabled: disabled, // || found && dates.eq(found.date, new Date(), 'day') && dates.lte(start, new Date()),
          slotType: found ? found.slotType : allDaySelected ? 'AVAILABLE' : 'UNAVAILABLE',
          label: startLabel, //dateLocalizer.format(start, 'HH:mm'/*format(props)*/, props.culture),
          labelAmPm: start.format('A'),
          // dayPart: dates.lte(start, noon) ? 'morning' : (dates.gt(start, noon) && dates.lt(start, evening) ? 'afternoon' : 'evening'),
        });

        start.add(props.step || 30, 'minutes');
      }

      return newTimes;
    },
    [selectedDay, props.step, region]
  );

  // @widgetEditable
  const handleChange = useCallback(
    date => {
      const { /*views, */ onChange } = props;
      // var { view } = this.state;

      // if (views[0] === view || views[1] === view) {
      setCurrentDate(date);
      setWeekDayLabel(getHeaderLabel(date));
      setMonthLabel(getMomentWithTz(date /*currentDate*/, region!).format('MMMM' /*, culture*/));
      setIsWeekly(false); // Reset before opening
      setClearAll(false); // Reset before opening

      // notify(onChange, date);

      onChange && onChange(date);

      focus();

      // panelRef?.current?.show();
      setAvailabilityTimePickerDrawerOpen(true);

      // return;
      // }

      // this.navigate('DOWN', date);

      // this.navigate(DOWN, date)

      // this.setCurrentDate(date);

      // notify(onChange, date);

      // this.focus();

      // eslint-disable-next-line react-hooks/exhaustive-deps
    },
    [getHeaderLabel, setCurrentDate, props.onChange, region, culture]
  );

  // const closeAvailabilityTimeDrawer = useCallback(() => {
  //   if (availabilityTimePickerDrawerOpen) {
  //     // @ts-ignore
  //     panelRef?.current && panelRef?.current?.hide();
  //   }

  //   // setAvailabilityTimePickerDrawerOpen(false);
  // }, [availabilityTimePickerDrawerOpen, setAvailabilityTimePickerDrawerOpen]);

  const handleBottomReached = useCallback(() => {
    // panelRef.current && panelRef.current.hide();
    if (availabilityTimePickerDrawerOpen) {
      setAvailabilityTimePickerDrawerOpen(false);
    }
    // setIsOpen(false);
  }, [availabilityTimePickerDrawerOpen, setAvailabilityTimePickerDrawerOpen]);

  const handleFullyOpen = useCallback(() => {
    const timeSlots = populateTimeSlots();

    // setTimeSlots(timeSlots);
    timeSlotsRef.current = timeSlots;
    setTimes(getTimes(timeSlots));
    setTimesHash(Math.random());

    //     times: this.getTimes(timeSlots),
    //     timesHash: ,
  }, [populateTimeSlots, getTimes]);

  const handleAvailabilityTimePickerClose = () => {
    // setDayAvailabilityWeekly([]);
    setAvailabilityTimePickerDrawerOpen(false);
  };

  const clearAllTimeSlots = useCallback(() => {
    const timeSlotsCopy = timeSlotsRef.current.slice();
    // let index = 0;

    timeSlotsCopy?.forEach(ts => {
      const slotType = ts.slotType;

      if (slotType === 'AVAILABLE') {
        ts.slotType = 'UNAVAILABLE';
      }
    });

    // TODO: potential bug in counting, when there're slots with IN_SESSION status
    setBookingHours(0);
    setIsAllDay(false);
    setClearAll(true);
    // setTimeSlots(timeSlotsCopy);
    setTimes(getTimes(timeSlotsCopy));
    setTimesHash(Math.random());

    // this.setState({
    //   isAllDay: false,
    //   bookingHours: 0,
    //   times: this.getTimes(timeSlotsCopy),
    //   timesHash: Math.random(),
    // });

    // mBookingHours = bookingHours;

    // mTimeSlots.clear();

    // mTimeSlots = timeSlots;

    // mAdapter.setTimeSlots(timeSlots);
    //        mAdapter.notifyDataSetChanged();
    //        mGridView.setAdapter(mAdapter);
    // mGridView.invalidateViews();
  }, [getTimes]);

  const handleSelectAllTimeSlots = useCallback(() => {
    const timeSlotsCopy = timeSlotsRef.current.slice();
    let _bookingHours = 0;
    // let index = 0;

    setIsAllDay(true);
    setClearAll(false);
    // setTimeSlots(timeSlotsCopy);

    var times = getTimes(timeSlotsCopy, true);

    // TODO not the best solution, sort out later
    var newTimeSlots: TimeSlot[] = [];

    times.forEach(val => {
      let slotType = val.slotType;

      if (slotType === 'UNAVAILABLE') {
        slotType = 'AVAILABLE';

        _bookingHours++;
      } else if (val.slotType === 'AVAILABLE') {
        _bookingHours++;
      }

      newTimeSlots.push({
        start: val.date,
        startTime: val.label,
        startTimeWithAmPm: `${val.label} ${val.labelAmPm}`,
        end: dates.add(val.date, 30, 'minutes'),
        endTime: val.label, // not used, so we can assign anything
        slotType,
      });
    });

    timeSlotsRef.current = newTimeSlots;

    setTimes(getTimes(newTimeSlots));
    setBookingHours(_bookingHours);
    setTimesHash(Math.random());

    // this.setState({
    //   isAllDay: true,
    //   bookingHours,
    //   times: this.getTimes(timeSlotsCopy),
    //   timesHash: Math.random(),
    // });

    // mBookingHours = bookingHours;

    // mTimeSlots.clear();

    // mTimeSlots = timeSlots;

    // mAdapter.setTimeSlots(timeSlots);
    //        mAdapter.notifyDataSetChanged();
    //        mGridView.setAdapter(mAdapter);
    // mGridView.invalidateViews();
  }, [getTimes]);

  const handleTimeSlotSelected = useCallback(
    (/*HashMap<String, String> */ timeSlot: Date) => {
      const timeSlotsCopy = timeSlotsRef.current.slice();
      const found = timeSlotsCopy?.find(ts => ts.start?.getTime() === timeSlot.getTime());
      let allDay = false;

      // if (!found || found.slotType === 'IS_NOT_AVAILABLE_FOR_BOOKING' || found.slotType === 'IN_SESSION') {
      if ((found && found.slotType === 'IS_NOT_AVAILABLE_FOR_BOOKING') || (found && found.slotType === 'IN_SESSION')) {
        return;
      }

      if (found && found.slotType === 'UNAVAILABLE') {
        found.slotType = 'AVAILABLE';
        allDay = allDaySelected();
      } else if (found) {
        found.slotType = 'UNAVAILABLE';
      } else {
        timeSlotsCopy.push({
          slotType: 'AVAILABLE',
          start: timeSlot,
          startTime: getMomentWithTz(timeSlot, region!).format('HH:mm'),
          startTimeWithAmPm: getMomentWithTz(timeSlot, region!).format('h:mm A'),
          end: getMomentWithTz(timeSlot, region!)
            .add(30, 'minutes')
            .toDate(),
          endTime: getMomentWithTz(timeSlot, region!)
            .add(30, 'minutes')
            .format('HH:mm'),
        });
      }

      // this.setState({
      //   timeSlots: timeSlotsCopy,
      //   times: this.getTimes(timeSlotsCopy),
      //   timesHash: Math.random(),
      //   isAllDay
      // });

      setIsAllDay(allDay);
      setClearAll(false);
      // setTimeSlots(timeSlotsCopy);
      timeSlotsRef.current = timeSlotsCopy;
      setTimes(getTimes(timeSlotsCopy));
      setTimesHash(Math.random());

      // if (ts.get("startTime").equals(timeSlot.get("startTime")) && ts.get("endTime").equals(timeSlot.get("endTime"))) {

      //     if (timeSlot.get("slotType").equals("")) {
      //         timeSlot.put("slotType", "AVAILABLE");
      //     } else {
      //         timeSlot.put("slotType", "UNAVAILABLE");
      //     }
      // }

      // if (timeSlot.get("slotType").equals("IS_NOT_AVAILABLE_FOR_BOOKING") ||
      //   timeSlot.get("slotType").equals("IN_SESSION")) {
      //   return;
      // }

      // Drawable background = view.getBackground();

      // // Toggle background and text color
      // if (timeSlot.get("slotType").equals("AVAILABLE")) {
      //     LayerDrawable layerDrawable = (LayerDrawable) background;
      //     GradientDrawable outer = (GradientDrawable) layerDrawable.findDrawableByLayerId(R.id.outer);
      //     GradientDrawable inner = (GradientDrawable) layerDrawable.findDrawableByLayerId(R.id.inner);
      //     outer.setColor(ContextCompat.getColor(mContext, R.color.com_trubeapp_grey));
      //     outer.setStroke(1, ContextCompat.getColor(mContext, R.color.com_trubeapp_grey));
      //     inner.setColor(Color.TRANSPARENT);
      //     ((TextView)view).setTextColor(Color.BLACK);
      // } else if (timeSlot.get("slotType").equals("UNAVAILABLE")) {
      //      LayerDrawable layerDrawable = (LayerDrawable) background;
      //      GradientDrawable outer = (GradientDrawable) layerDrawable.findDrawableByLayerId(R.id.outer);
      //      GradientDrawable inner = (GradientDrawable) layerDrawable.findDrawableByLayerId(R.id.inner);
      //      outer.setColor(ContextCompat.getColor(mContext, R.color.com_trubeapp_red));
      //      outer.setStroke(1, ContextCompat.getColor(mContext, R.color.com_trubeapp_red));
      //      inner.setColor(Color.TRANSPARENT);
      //      ((TextView)view).setTextColor(Color.WHITE);
      //  }

      //             // Toggle slot type
      //             for (HashMap<String, String> ts : mTimeSlots) {
      //                 if (ts.get("startTime").equals(timeSlot.get("startTime")) && ts.get("endTime").equals(timeSlot.get("endTime"))) {

      //                     if (timeSlot.get("slotType").equals("UNAVAILABLE")) {
      //                         timeSlot.put("slotType", "AVAILABLE");
      //                     } else {
      //                         timeSlot.put("slotType", "UNAVAILABLE");
      //                     }
      //                 }
      //             }

      //             refreshTimeSlotsList();

      //             if (mTimeSlotSelectionEventListener != null) {
      //                 mTimeSlotSelectionEventListener.onTimeSlotClick(TimeSlotPickerView.this, timeSlot);
      //             }
      //         }
      //     });
    },
    [getTimes, region]
  );

  const handleSetEveryWeekdayConfirm = useCallback(() => {
    setIsWeekly(true);
    setIsSetEveryWeekdayDialogOpen(false);
  }, []);

  const handleClearAllTimeSlotsConfirm = useCallback(() => {
    clearAllTimeSlots();
    setClearAllTimeSlotsDialogOpen(false);
  }, [clearAllTimeSlots]);

  const handleIsWeeklyChange = useCallback(
    () => (isWeekly ? setIsWeekly(false) : setIsSetEveryWeekdayDialogOpen(true)),
    [isWeekly]
  );

  const handleClearClick = useCallback(() => setClearAllTimeSlotsDialogOpen(true), []);

  const handleConfirm = useCallback(() => {
    const dayStr = dateLocalizer.format(selectedDay, 'YYYY-MM-DD' /*format(props)*/, culture);

    // var start = values.min; // dates.add(values.min, timezoneOffset, 'minutes'); // Normalize min time according to the time zone
    // const selectedDay = this.props.selectedDay;

    // @ts-ignore
    let start = getMomentWithTz(selectedDay, region).startOf('day');
    // @ts-ignore
    let _minDate = getMomentWithTz(selectedDay, region).startOf('month');

    // const end = dates.add(minDate, 3, 'month');
    const end = maxDate;
    // const end = dates.endOf(selectedDay, 'month');

    // @ts-ignore
    _minDate = clamp(_minDate.toDate(), todaysDate, _minDate.toDate(), region);

    // Get start min date of weekday within range
    while (
      start.isSameOrAfter(_minDate) &&
      start
        .clone()
        .add(-7, 'day')
        .isSameOrAfter(_minDate)
    ) {
      start.add(-7, 'day');
    }

    let dayAvailabilityWeekly: Availability /*Availability[]*/ = {};
    let dayAvailabilityCopy: Availability = Object.assign({}, dayAvailability?.content);
    let newDayAvailability: Availability /*Availability[]*/ = {};

    if (isWeekly) {
      while (start.isSameOrBefore(end)) {
        let day = start.format('YYYY-MM-DD' /*, culture*/);

        // const existingDay = dayAvailabilityCopy?.find(v => moment.utc(v.start).isSame(start));

        let _isAllDay = isAllDay;

        // newDayAvailability = [];

        let dayStart = start.clone().startOf('day');
        dayStart = dayStart.clone().add(330, 'minutes');
        let dayEnd = dayStart.clone().endOf('day');
        dayEnd = dayEnd.clone().add(-30, 'minutes');
        // dayEnd = dates.add(dayEnd, 1, 'seconds');

        while (dayStart.isSameOrBefore(dayEnd)) {
          let time = dayStart.format('h:mm A' /*, culture*/);
          const timeSlot = timeSlotsRef.current.find(ts => ts.startTimeWithAmPm === time);
          // const existingTs = timeSlotsRef.current.find(ts => /*dates.day(dayStart) === dates.day(ts.start) && dates.month(dayStart) === dates.month(ts.start) && */ts.startTime === time);

          if (
            !bookedTimeSlots ||
            !(
              bookedTimeSlots.hasOwnProperty(dayStart.toISOString()) // ||
              // bookedTimeSlots.hasOwnProperty(dates.add(dayStart, -30, 'minutes').toISOString()) ||
              // bookedTimeSlots.hasOwnProperty(dates.add(dayStart, -60, 'minutes').toISOString()) ||
              // bookedTimeSlots.hasOwnProperty(dates.add(dayStart, 30, 'minutes').toISOString()) ||
              // bookedTimeSlots.hasOwnProperty(dates.add(dayStart, 60, 'minutes').toISOString())
            )
          ) {
            // if (
            //   existingTs &&
            //   existingTs.slotType !== 'IS_NOT_AVAILABLE_FOR_BOOKING' &&
            //   existingTs.slotType !== 'IN_SESSION'
            // ) {
            //   dayAvailabilityWeekly[dayStart.toISOString()] = existingTs?.slotType === 'AVAILABLE';
            // } else {
            dayAvailabilityWeekly[dayStart.toISOString()] = timeSlot?.slotType === 'AVAILABLE';
          }

          dayStart.add(30, 'minutes');
        }

        // Check for slots with slot types of `IS_NOT_AVAILABLE_FOR_BOOKING` and
        // `IN_SESSION` not to overwrite them
        // const _timeSlots = timeSlotsRef.current.reduce((timeSlotsAcc: Availability[], nextTimeSlot: TimeSlot) => {
        //   // const existingTs = dayAvailabilityCopy?.find(v => moment.utc(v.start).isSame(nextTimeSlot.start));

        //   // if (existingTs?.slotType !== 'IS_NOT_AVAILABLE_FOR_BOOKING' && existingTs?.slotType !== 'IN_SESSION') {
        //   if (nextTimeSlot?.slotType !== 'IS_NOT_AVAILABLE_FOR_BOOKING' && nextTimeSlot?.slotType !== 'IN_SESSION') {
        //     timeSlotsAcc.push({
        //       start: dates.merge(start, nextTimeSlot.start).toISOString(),
        //       active: nextTimeSlot.slotType === 'AVAILABLE',
        //     });
        //   }
        //   // } else if (isAllDay) {
        //   // _isAllDay = false;
        //   // }

        //   return timeSlotsAcc;
        // }, []) as Availability[];

        // if (_timeSlots.length) {
        //   // dayAvailabilityWeekly.push({
        //   //   day,
        //   //   allDay: _isAllDay,
        //   //   timeSlots: _timeSlots,
        //   // });
        //   dayAvailabilityWeekly.push(..._timeSlots);
        // }

        start.add(7, 'day');
      }

      newDayAvailability = dayAvailabilityCopy || {};

      // Update current day availability
      Object.keys(dayAvailabilityWeekly).forEach((val: string) => {
        if (newDayAvailability.hasOwnProperty(val)) {
          // exists
          // newDayAvailability[val] = dayAvailabilityWeekly[val];
          // // newDayAvailability.push(val);
          // // newDayAvailability.push.active = val.active;

          if (!dayAvailabilityWeekly[val]) {
            delete newDayAvailability[val];
          }
        } else if (dayAvailabilityWeekly[val]) {
          // add new
          newDayAvailability[val] = undefined; //dayAvailabilityWeekly[val];
        }

        // dayAvailabilityCopy = dayAvailabilityCopy.concat(newDa.timeSlots.map(newTs => ({
        //     start: newTs.start.toISOString(),
        //     active: newTs.slotType === 'AVAILABLE' //!clearAll
        //   })));

        //   // if (dayToChange) {

        //     // dayToChange.allDay = newDa.allDay;
        //     // dayToChange.timeSlots = dayToChange.timeSlots?.map(oldTs => {
        //     //   const newTs = newDa.timeSlots.find(v => v.startTime === oldTs.startTime);

        //     //   if (newTs && newTs.slotType !== 'IS_NOT_AVAILABLE_FOR_BOOKING' && newTs.slotType !== 'IN_SESSION') {
        //     //     return newTs;
        //     //   } else if (clearAll && oldTs.slotType !== 'IS_NOT_AVAILABLE_FOR_BOOKING' && oldTs.slotType !== 'IN_SESSION') {
        //     //     return { ...oldTs, slotType: 'UNAVAILABLE' };
        //     //   // } else {
        //     //   //   return { ...oldTs, slotType: newDa.allDay ? 'AVAILABLE' : 'UNAVAILABLE' }
        //     //   }

        //     //   return oldTs;
        //     // })
        //   // }
      });

      // newDayAvailability = newDayAvailability.reduce((acc, val) => {
      //   if (val.active !== false) {
      //     acc.push(val);
      //   }

      //   return acc;
      // }, [] as Availability[]);
    } else {
      // let dayStr = moment.utc(selectedDay).format('YYYY-MM-DD');

      newDayAvailability = timeSlotsRef.current.reduce((acc, ts) => {
        if (ts.slotType === 'AVAILABLE') {
          // UTC format
          // @ts-ignore
          acc[ts.start.toISOString()] = undefined;
        } else {
          // UTC format
          // @ts-ignore
          delete dayAvailabilityCopy[ts.start.toISOString()];
        }

        return acc;
      }, {} as Availability /*[] as Availability[]*/);

      // if (timeSlot && timeSlot.slotType === 'AVAILABLE') {
      //   acc.push({ start: moment.utc(timeSlot.start).format('YYYY-MM-DD[T]HH:mm:ss') });
      // }

      // return {
      //   ...v,
      //   allDay: isAllDay,
      //   timeSlots: timeSlotsRef.current.map(ts => ({
      //     startTime: ts.startTime,
      //     endTime: ts.endTime,
      //     slotType: ts.slotType,
      //   })),
      // };

      //
      newDayAvailability = Object.assign({}, dayAvailabilityCopy, newDayAvailability);
    }

    if (newDayAvailability) {
      setDayAvailability({ hash: Math.random(), content: newDayAvailability });
    }

    // Prepare data to send to the BE
    if (isWeekly) {
      // if (isWeekly && newDayAvailability && newDayAvailability.length) {
      // if (isWeekly && dayAvailabilityWeekly && dayAvailabilityWeekly.length) {

      newDayAvailability = dayAvailabilityWeekly;
      // newDayAvailability = dayAvailabilityWeekly.reduce(
      //   (acc: TimeSlot[], day: DayAvailability) => (acc.concat(day.timeSlots), acc),
      //   [] as Availability[]
      // );

      // newDayAvailability = dayAvailabilityWeekly?.map(newDa => {
      //   const timeSlots = newDa.timeSlots.reduce((acc: TimeSlot[], ts: TimeSlot) => {
      //       if (ts.slotType === 'AVAILABLE') {
      //         acc.push({ 'startTime': ts.startTime });
      //       }

      //       return acc;
      //     }, []);

      //   return Object.assign({}, { day: newDa.day, allDay: newDa.allDay }, timeSlots && timeSlots.length && { timeSlots });
      // });
    } else {
      newDayAvailability = {};

      // @ts-ignore
      let start = getMomentWithTz(selectedDay, region).startOf('day');
      start.add(330, 'minutes');
      let end = start.clone().endOf('day');
      end.add(-30, 'minutes');
      // end = dates.add(end, 1, 'seconds');

      while (start.isSameOrBefore(end)) {
        let time = start.format('h:mm A' /*, culture*/);

        const existingTs = timeSlotsRef.current.find(ts => ts.startTimeWithAmPm === time);

        if (
          existingTs &&
          existingTs.slotType !== 'IS_NOT_AVAILABLE_FOR_BOOKING' &&
          existingTs.slotType !== 'IN_SESSION'
        ) {
          newDayAvailability[existingTs!.start!.toISOString()] = existingTs?.slotType === 'AVAILABLE';
        } else {
          newDayAvailability[start.toISOString()] = false;
        }

        start.add(30, 'minutes');
      }

      // newDayAvailability = timeSlotsRef.current.map(ts => ts.slotType === 'AVAILABLE' ? { start: ts.start.toISOString(), active: true } : null).filter(v => v);

      // newDayAvailability = dayAvailability?.content?.reduce((dayAvailabilityAcc: DayAvailability[], v) => {
      //   let newValue = {
      //     day: v.day,
      //     allDay: v.allDay,
      //     timeSlots: v.timeSlots?.slice(),
      //   };

      //   if (newValue.day === dayStr) {
      //     newValue.allDay = isAllDay;

      //     if (timeSlotsRef.current && !isAllDay) {
      //       // for(TimeSlot ets : elemTimeSlots) {
      //       //                           if (ets.getStartTime().equals(ts.get("startTime"))) {
      //       //                               ets.setSlotType(ts.get("slotType"));
      //       //                           }
      //       //                       }

      //       //                       if (ts.get("slotType").equals("AVAILABLE")) {
      //       //                           TimeSlot newTimeSlot = new TimeSlot();

      //       //                           newTimeSlot.setStartTime(ts.get("startTime"));
      //       //                           newTimeSlotList.add(newTimeSlot);
      //       //                       }

      //       // newValue.timeSlots.map(ets => {
      //       //   const foundTimeSlot = timeSlots.find(slot => slot.startTime === ets.startTime);

      //       //   if (foundTimeSlot) {
      //       //     ets.slotType = foundTimeSlot.slotType;
      //       //   }
      //       // });

      //       newValue.timeSlots = timeSlotsRef.current.reduce((acc: TimeSlot[], ts: TimeSlot) => {
      //         if (ts.slotType === 'AVAILABLE') {
      //           acc.push({ startTime: ts.startTime });
      //         }

      //         return acc;
      //       }, []) as TimeSlot[];
      //     } else {
      //       newValue.timeSlots?.map(ts => {
      //         if (isAllDay) {
      //           if (ts.slotType === 'UNAVAILABLE') {
      //             ts.slotType = 'AVAILABLE';
      //           }
      //         } else {
      //           if (ts.slotType === 'AVAILABLE') {
      //             ts.slotType = 'UNAVAILABLE';
      //           }
      //         }

      //         return ts;
      //       });

      //       //  for(TimeSlot ets : elemTimeSlots) {
      //       //     if (isAllDay) {
      //       //         if (ets.getSlotType().equals("UNAVAILABLE")) {
      //       //             ets.setSlotType("AVAILABLE");
      //       //         }
      //       //     } else {
      //       //         if (ets.getSlotType().equals("AVAILABLE")) {
      //       //             ets.setSlotType("UNAVAILABLE");
      //       //         }
      //       //     }
      //       // }
      //     }

      //     // if (ts.get("slotType").equals("AVAILABLE")) {
      //     //   TimeSlot newTimeSlot = new TimeSlot();

      //     //   newTimeSlot.setStartTime(ts.get("startTime"));
      //     //   newTimeSlotList.add(newTimeSlot);
      //     // }

      //     //      {
      //     //           for(TimeSlot ets : elemTimeSlots) {
      //     //               if (ets.getStartTime().equals(ts.get("startTime"))) {
      //     //                   ets.setSlotType(ts.get("slotType"));
      //     //               }
      //     //           }

      //     //       }
      //     //   } else {
      //     // }
      //     dayAvailabilityAcc.push(newValue);
      //   }

      //   return dayAvailabilityAcc;
      // }, []) as DayAvailability[];
    }

    // newDayAvailability

    updateAvailability(
      user?.id!,
      Object.keys(newDayAvailability).map(v => ({ start: v, active: newDayAvailability[v] }))
    ).finally(() => {
      setAvailabilityTimePickerDrawerOpen(false);
    });
  }, [
    user,
    /*minDate, */ todaysDate,
    maxDate,
    dayAvailability,
    bookedTimeSlots,
    selectedDay,
    isAllDay,
    clearAll,
    isWeekly,
    region,
    culture,
    setDayAvailability,
    updateAvailability,
  ]);

  // const handleConfirmWeekly = useCallback((availability: DayAvailability[]) => {
  //   if (!availability || !availability?.length) {
  //     return;
  //   }

  //   let dayAvailabilityCopy = dayAvailability?.content?.slice();

  //   availability.forEach(da => {
  //     let dayToChange = dayAvailabilityCopy?.find(v => v.day === da.day);

  //     if (dayToChange) {
  //       dayToChange.allDay = da.allDay;
  //       dayToChange.timeSlots = da.timeSlots;
  //     }
  //   });

  //   if (dayAvailabilityCopy) {
  //     setDayAvailability({ hash: Math.random(), content: dayAvailabilityCopy });
  //   }

  //   // Prepare data to send to the BE
  //   let dayAvailabilityWeekly = availability?.map(v => {
  //     return {
  //       ...v,
  //       timeSlots: v.timeSlots?.reduce((acc: TimeSlot[], ts: TimeSlot) => {
  //         if (ts.slotType === 'AVAILABLE') {
  //           acc.push({ 'startTime': ts.startTime });
  //         }

  //         return acc;
  //       }, []),
  //     };
  //   });

  //   // if (dayAvailabilityWeekly && dayAvailabilityWeekly.length && setWeekly) {
  //   //   setDayAvailabilityWeekly(dayAvailabilityWeekly);
  //   //   // updateAvailability(user?.id!, dayAvailabilityWeekly)
  //   //   //   .finally(() => {
  //   //   //     setAvailabilityTimePickerDrawerOpen(false);
  //   //   //   });
  //   // } else {
  //   //   setDayAvailabilityWeekly([]);
  //   // }
  // }, [user]);

  // Partner partner = Storage.instance().getPartner();

  // List<DayAvailability> newDayAvailabilityList = new ArrayList<>();

  // Iterator<DayAvailability> iter = dayAvailabilityList.listIterator();

  // SimpleDateFormat sdf = new SimpleDateFormat("yyyy-MM-dd", Locale.ENGLISH);

  // String date = sdf.format(day.getTime());

  // while (iter.hasNext()) {

  //     DayAvailability elem = iter.next();

  //     if (date.equals((elem.getDay()))) {
  //         List<TimeSlot> newTimeSlotList = new ArrayList<>();
  //         DayAvailability newDayAvailability = new DayAvailability();
  //         List<TimeSlot> elemTimeSlots = elem.getTimeSlots();

  //         newDayAvailability.setDay(date);
  //         newDayAvailability.setAllDay(String.valueOf(isAllDay));

  //         if (timeSlots != null && !isAllDay) {

  //             for(HashMap<String, String> ts : timeSlots) {
  //                 for(TimeSlot ets : elemTimeSlots) {
  //                     if (ets.getStartTime().equals(ts.get("startTime"))) {
  //                         ets.setSlotType(ts.get("slotType"));
  //                     }
  //                 }

  //                 if (ts.get("slotType").equals("AVAILABLE")) {
  //                     TimeSlot newTimeSlot = new TimeSlot();

  //                     newTimeSlot.setStartTime(ts.get("startTime"));
  //                     newTimeSlotList.add(newTimeSlot);
  //                 }
  //             }
  //         } else {
  //             for(TimeSlot ets : elemTimeSlots) {
  //                 if (isAllDay) {
  //                     if (ets.getSlotType().equals("UNAVAILABLE")) {
  //                         ets.setSlotType("AVAILABLE");
  //                     }
  //                 } else {
  //                     if (ets.getSlotType().equals("AVAILABLE")) {
  //                         ets.setSlotType("UNAVAILABLE");
  //                     }
  //                 }
  //             }
  //         }

  //         elem.setAllDay(String.valueOf(isAllDay));

  //         newDayAvailability.setTimeSlots(newTimeSlotList);

  //         newDayAvailabilityList.add(newDayAvailability);
  //     }
  // }

  // partner.setAvailability(newDayAvailabilityList);

  // final SetPartnerAvailability command = new SetPartnerAvailability(this, getProgressBarHandler(), timeSlots, avd.getAvailability().getDayAvailability(), isAllDay, day, callback);
  // command.execute();
  // }

  const focus = () => {};

  // const setHighlightedDays = (days: any[]) => {
  // _setHighlightedDays(days);
  // };

  // const setHasBookingsDays = (days: any[]) => {
  //   _setHasBookingsDays(days);
  // };

  // var currentDate = getCurrentDate();
  // var todaysDate = new Date();
  // todayNotInRange = !dates.inRange(todaysDate, min, max, view);

  // const key = 'view_month' + dates.month(currentDate);

  // const isRtl = false;

  // <div className='ap-calendar-footer'>
  //               <button
  //                   type='button'
  //                   className='ap-btn ap-calendar-btn ap-calendar-btn-left'
  //                   // onClick={this.handleMoveBack}
  //                   // disabled={isDisabled || !dates.inRange(this.nextDate('LEFT'), min, max, view)}
  //               >
  //                   <svg width='8' height='13' viewBox='0 0 8 13' xmlns='http://www.w3.org/2000/svg' className='tb-icon'>
  //                       <path fillRule='evenodd' d='M8 11.5L6.5 13L5.68248e-07 6.5L6.5 -1.31134e-07L8 1.5L3 6.5L8 11.5Z' />
  //                   </svg>
  //                   {/*{this.getHeaderLabel('LEFT')}*/}
  //               </button>
  //               <button
  //                   type='button'
  //                   className='ap-btn ap-calendar-btn ap-calendar-btn-right'
  //                   // onClick={this.handleMoveForward}
  //                   // disabled={isDisabled || !dates.inRange(this.nextDate('RIGHT'), min, max, view)}
  //                   // label={messages.moveForward()}
  //               >
  //                   {/*{this.getHeaderLabel('RIGHT')}*/}
  //                   <svg width='8' height='13' viewBox='0 0 8 13' xmlns='http://www.w3.org/2000/svg' className='tb-icon'>
  //                       <path fillRule='evenodd' d='M0 1.5L1.5 0L8 6.5L1.5 13L0 11.5L5 6.5L0 1.5Z' />
  //                   </svg>
  //               </button>
  //           </div>

  return (
    <>
      <div
        // {...elementProps}
        role="group"
        // focused={focused}
        // disabled={disabled}
        // readOnly={readOnly}
        tabIndex={tabIndex || 0}
        // onBlur={this.focusManager.handleBlur}
        // onFocus={this.focusManager.handleFocus}
        className={classes.apCalendar}
        // className={clsx(className, classes.apCalendar, 'ap-widget', 'ap-calendar', 'ap-widget-container', { 'ap-rtl': isRtl, 'ap-state-disabled': disabled, 'ap-state-readonly': readOnly, 'ap-state-focus': focused })}
        // aria-activedescendant={this.activeId}
      >
        {/*<Header
                // // isRtl={this.isRtl()}
                label={getHeaderLabel()}
                // prevLabel={this.getHeaderLabel('LEFT')}
                // nextLabel={this.getHeaderLabel('RIGHT')}
                // labelId={this.labelId}
                // messages={this.messages}
                // // upDisabled={isDisabled || view === last(views)}
                // prevDisabled={isDisabled || !dates.inRange(this.nextDate('LEFT'), min, max, view)}
                // nextDisabled={isDisabled || !dates.inRange(this.nextDate('RIGHT'), min, max, view)}
                // onViewChange={this.handleViewChange}
                // onMoveLeft ={this.handleMoveBack}
                // onMoveRight={this.handleMoveForward}
            />*/}
        {/*<SlideTransitionGroup direction={slideDirection}>*/}
        {/*<Month
                    // {...viewProps}
                    key={key}
                    // id={this.viewId}
                    // activeId={this.activeId}
                    value={value}
                    today={todaysDate}
                    disabled={disabled}
                    // prevDisabled={isDisabled || !dates.inRange(this.nextDate('LEFT'), min, max, 'week')}
                    // nextDisabled={isDisabled || !dates.inRange(this.nextDate('RIGHT'), min, max, 'week')}
                    focused={currentDate}
                    dayFormat={'dd'}
                    onChange={handleChange}
                    // aria-labelledby={this.labelId}
                    // onMoveLeft ={this.handleMoveBack}
                    // onMoveRight={this.handleMoveForward}
                />*/}
        <AvailabilityDayPickerView
          isFetching={isAvailabilityLoading}
          region={region}
          todaysDate={todaysDate}
          // currentDate={Date.now()/*todaysDate*/}
          onDaySelected={handleChange}
          dayAvailability={Object.keys(dayAvailability!.content!).map(v => ({ start: v }))}
          dayAvailabilityHash={dayAvailability?.hash}
          bookedTimeSlots={bookedTimeSlots}
        />

        {/*</SlideTransitionGroup>*/}

        {/*availabilityTimePickerDrawerOpen && (
            <div />
            )*/}
      </div>
      <TruBeDrawer
        attachRef={panelRef}
        // disabled={false}
        allowDragging={true}
        title={title}
        isOpen={availabilityTimePickerDrawerOpen}
        // activeState={this.props.bookingPanelState}
        // bookingDate={this.state.bookingDate}
        // onDateSelect={this.handleDateTimeChange}
        // onDateSelect={this.handleDirectBookingTimeChange}
        onFullyOpen={handleFullyOpen}
        onBottomReached={handleBottomReached}
        // onClose={closeAvailabilityTimeDrawer}
        onClose={handleAvailabilityTimePickerClose}
        // onNextClick={this.handleBookingPanelCtaClick}
      >
        {selectedDay && (
          <AvailabilityTimePickerView
            isFetching={isAvailabilityFetching}
            // allDay={isAllDay}
            isWeekly={isWeekly}
            region={region}
            selectedDay={selectedDay}
            // dayAvailability={dayAvailability?.content}
            // maxDate={}
            times={times}
            timesHash={timesHash}
            headerLabel={weekDayLabel}
            onTimeSlotSelected={handleTimeSlotSelected}
            onConfirm={handleConfirm}
            // onConfirmWeekly={handleConfirmWeekly}
            onIsWeeklyClick={handleIsWeeklyChange}
            onSelectAllTimeSlots={handleSelectAllTimeSlots}
            onClear={handleClearClick}
            onClose={handleAvailabilityTimePickerClose}
            // onClose={closeAvailabilityTimeDrawer}
          />
        )}
      </TruBeDrawer>
      <ClearAllTimeSlotsDialog
        open={clearAllTimeSlotsDialogOpen}
        // success={declineSuccess}
        onConfirm={handleClearAllTimeSlotsConfirm}
        onClose={() => {
          // setRunningLateSuccessOpen(false);
          setClearAllTimeSlotsDialogOpen(false);
          // setMenuOpen(false);
        }}
      />
      <SetEveryWeekdayDialog
        open={isSetEveryWeekdayDialogOpen}
        // success={declineSuccess}
        weekDayLabel={weekDayLabel}
        monthLabel={monthLabel}
        onConfirm={handleSetEveryWeekdayConfirm}
        onClose={() => {
          // setRunningLateSuccessOpen(false);
          setIsSetEveryWeekdayDialogOpen(false);
          // setMenuOpen(false);
        }}
      />
    </>
  );
  // // HOC Factory
  // function wrapComponent(WrappedComponent) {
  //     var displayName = WrappedComponent.displayName || WrappedComponent.name || 'Component';

  //     var minTime = BookingTime.getInitialDate().startOf('day').toDate();
  //     var maxTime = BookingTime.getInitialDate().endOf('month').add(2, 'M').endOf('month').toDate();

  //     const HOCComponent = createReactClass({
  //         displayName: `WithAvailabilityPicker(${displayName})`,
  //         propTypes: {
  //             bookingTime: PropTypes.instanceOf(Date),
  //             startTimes: PropTypes.object, // from passed mapStateToProps
  //         },

  //         // contextTypes: {
  //         //     filtersLocationType: PropTypes.number,
  //         //     filtersDayAndTime: PropTypes.shape({}),
  //         //     filtersBookingDate: PropTypes.string,
  //         //     changeDirectBookingDateFilter: PropTypes.func,
  //         // },

  //         getInitialState () {
  //             const { bookingTime, confirmedBooking } = this.props;
  //             var timeSlots,
  //                 availableDays = [];

  //             var query = new URLSearchParams(this.props.location.search);
  //             var startTime = query.get('start_time');

  //             this.bookingTime = new BookingTime(startTime && !ignoreStartTimeQueryParam ? new Date(Number(startTime)) : new Date(bookingTime));

  //             let startTimes = this.props.startTimes && Object.keys(this.props.startTimes).length
  //                 ? this.props.startTimes
  //                 : confirmedBooking && confirmedBooking.partner && confirmedBooking.partner.startTimes;

  //             if (startTimes) {
  //                 availableDays = Object.keys(startTimes);

  //                 // if (!this.bookingTime.isValid()) {
  //                 if (!startTime || ignoreStartTimeQueryParam) {
  //                     this.nextAvailableDate(startTimes);
  //                 }
  //                 // }

  //                 timeSlots = this.getTimeSlots(startTimes);
  //             }

  //             return {
  //                 availableDays,
  //                 timeSlots,
  //             };
  //         },

  //         UNSAFE_componentWillMount () {
  //         },

  //         UNSAFE_componentWillReceiveProps (nextProps) {
  //             var timeSlots,
  //                 availableDays = [];

  //             if (!_.isShallowEqual(nextProps.startTimes, this.props.startTimes)) {
  //                 availableDays = Object.keys(nextProps.startTimes);

  //                 var query = new URLSearchParams(this.props.location.search);
  //                 var startTime = query.get('start_time');

  //                 // We can't just set next available time, as in Checkout it'll
  //                 // default time to the next available. We check for start_time
  //                 // query string is not present to not reset the time

  //                 // REMOVE THIS COMMENT LATER:
  //                 // BUG!!
  //                 // This check will control setting the date in the Time Slots Pop-up
  //                 // In situations when there's start_time by any reason in the URL
  //                 // it'll skip the date set in the Day & Time Picker on the Partner List page
  //                 // The last check this.bookingTime.isValid() is messing with Checkout page
  //                 if (!startTime || ignoreStartTimeQueryParam/* || !this.bookingTime.isValid()*/) {
  //                     this.nextAvailableDate(nextProps.startTimes);
  //                 }

  //                 // Is it okay to set time slots after we get nextAvailableDate
  //                 timeSlots = this.getTimeSlots(nextProps.startTimes);

  //                 this.setState({
  //                     availableDays,
  //                     timeSlots,
  //                 });
  //             }
  //         },

  //         componentDidUpdate (prevProps) {
  //             // Clearing the booking time
  //             if (prevProps.bookingTime && this.props.bookingTime === null) {
  //                 this.bookingTime.clear();
  //                 this.forceUpdate();
  //             }
  //         },

  //         render() {
  //             return React.createElement(WrappedComponent, {
  //                 ...this.props,
  //                 bookingTime: this.bookingTime.getDate(),
  //                 minTime,
  //                 maxTime,
  //                 availableDays: this.state.availableDays,
  //                 timeSlots: this.state.timeSlots,
  //                 nextAvailableDate: this.nextAvailableDate,
  //                 changeBookingTime: this.bookingTimeChangeHandler,
  //                 // ref: innerRef || this.attachRef,
  //             });
  //         },

  //         // TODO: decide later how to pass culture locale
  //         bookingTimeChangeHandler (value, ...args) {
  //             const { filtersDayAndTime } = this.context;
  //             const { startTimes } = this.props;
  //             const newDate = getMoment(value);

  //             const timesOfDay = filtersDayAndTime.filter(v => v.label);

  //             if (value && newDate.isValid()) {
  //                 let timeSlots;

  //                 timeSlots = this.getTimeSlots(startTimes, value/*this.bookingTime.getDate()*/);

  //                 if (args[0] && args[1]) { // if we went from BookingFlowDateTimeSelector
  //                     this.bookingTime.setDate(value);
  //                     this.props.updateBookingDateTime({ bookingTimeFormatted: this.bookingTime.format('YYYY-MM-DD[T]HH:mm'), bookingTime: this.bookingTime.getTime() });
  //                 } else if (args[1] && !args[0] || /* if we went from NewCalendar in mobiles or from Time Slots when pick date */
  //                     inRangeTime(value, minTime, maxTime, timeSlots) && (!timesOfDay || !timesOfDay.length))
  //                 {
  //                     this.bookingTime.setDate(value);
  //                     // this.context.changeDirectBookingDateFilter({ directBookingDate: newDate.valueOf() });
  //                 } else if (startTimes) {
  //                     this.nextAvailableDate(startTimes, newDate);
  //                 }

  //                 this.setState({ bookingTime: this.bookingTime.getDate(), timeSlots });

  //                 if (args[0]) {
  //                     this.props.updateBookingDateTime({
  //                         bookingTimeFormatted: this.bookingTime.format('YYYY-MM-DD[T]HH:mm'),
  //                         bookingTime: this.bookingTime.getTime(),
  //                         directBookingDate: this.bookingTime.getTime(),
  //                     });
  //                 }

  //             }
  //         },

  //         /*
  //          * @param {Array} dates available days of a partner.
  //          * @param {Object} date Moment|BookingTime object
  //          *
  //          * @example ['2018-11-03', ..]
  //          */
  //         getTimeSlots (dates, date = this.bookingTime) {
  //             var momentDate,
  //                 dateFormatted;

  //             if (!date || !dates) {
  //                 return;
  //             }

  //             momentDate = date instanceof BookingTime
  //                 ? getMoment(date.getDate())
  //                 : getMoment(date);

  //             dateFormatted = momentDate.format('YYYY-MM-DD'); // TODO: make to BookingTime

  //             return dates[dateFormatted] && dates[dateFormatted].startTimes || dates[dateFormatted] || [];
  //         },

  //         /*
  //          * Hashmap with dates
  //          * Sets BookingTime's time
  //          * Expects dates in the following form. Used in UNSAFE_componentWillReceiveProps
  //          * If date is set then we went from onChange handler
  //          * Depends on filters!! from Day & Time Picker
  //          *
  //          * @example { '2020-06-17': { date: new Date(), label: 12 AM }, .. }
  //          * @param Array dates mapped array
  //          */

  //         nextAvailableDate (dates, date) {
  //             const { filtersLocationType, filtersDayAndTime } = this.context;
  //             var availableDates, // list of all available dates
  //                 matchedDaysOfWeek = [], // list of days that met a criteria
  //                 matchedTimesOfDay = []; // list of times that met a criteria
  //             var now = getMoment();
  //             var nextDate;
  //             var afterDate = date;

  //             if (!dates) {
  //                 return;
  //             }

  //             if (!(date && date.isSameOrAfter(now))) {
  //                 afterDate = now;
  //             }

  //             availableDates = Object.keys(dates);

  //             if (!availableDates || !availableDates.length) {
  //                 return;
  //             }

  //             if (BookingTime.alignedToHalfAnHour) {
  //                 BookingTime.roundToHalfAnHour(afterDate);

  //             }

  //             if (afterDate.isBefore(getMoment().add(filtersLocationType === LOCATION_TYPES.LOCATION_TYPE_IN_PERSON ? 3 : 1, 'hours'))) {
  //                 afterDate.add(filtersLocationType === LOCATION_TYPES.LOCATION_TYPE_IN_PERSON ? 3 : 1, 'hours');
  //             }

  //             const daysOfWeek = filtersDayAndTime.filter(v => !v.label);
  //             const timesOfDay = filtersDayAndTime.filter(v => v.label);

  //             if (daysOfWeek.length) {
  //                 matchedDaysOfWeek = availableDates
  //                     .filter(day => {
  //                         let date = getMoment(day, 'YYYY-MM-DD');
  //                         let weekDayName = date.format('ddd'); // Mon, Tue, etc.

  //                         return date.isSameOrAfter(afterDate) && daysOfWeek.some(d => d.name === weekDayName);
  //                     });
  //             }

  //             const filtersBookingDate = date && date.isValid()
  //                 ? date.format('DD MMM YYYY')
  //                 : this.context.filtersBookingDate;

  //             // this.context.filtersBookingDate is not up to date afer selecting in TimeSlotsPopup
  //             // that's why we check bookingTime first if it exists
  //             if (filtersBookingDate) {
  //                 matchedDaysOfWeek = availableDates
  //                     .filter(day => {
  //                         let date = getMoment(day, 'YYYY-MM-DD');
  //                         let bookingDate = getMoment(filtersBookingDate, 'DD MMM YYYY'); //

  //                         return date.isSame(bookingDate, 'day');
  //                     });
  //             }

  //             const pickMatchedTimeSlots = slot => {
  //                 const date = getMoment(slot.date);
  //                 const hour = date.hour();
  //                 const minutes = date.minutes();

  //                 // ???
  //                 const _afterDate = afterDate.isSame(new Date(), 'day') ? afterDate : afterDate.clone().startOf('day');

  //                 return timesOfDay.some((tod) => {
  //                     return date.isSameOrAfter(_afterDate) &&
  //                         ((tod.id === 'morning' && (hour * 60 + minutes) >= 330 && hour <= 12) ||
  //                         (tod.id === 'midday'  && hour >= 12 && hour <= 16) ||
  //                         (tod.id === 'evening' && hour >= 16 && hour <= 23));
  //                 });
  //             };

  //             const pickMatchedTimesOfDay = day => {
  //                 let slots = dates[day];

  //                 return slots.find(pickMatchedTimeSlots);
  //             };

  //             if (timesOfDay.length) {
  //                 matchedTimesOfDay = availableDates
  //                     .filter(pickMatchedTimesOfDay);
  //             }

  //             const intersectedDays = matchedDaysOfWeek.filter(value => matchedTimesOfDay.includes(value));

  //             if (intersectedDays.length) {
  //                 intersectedDays
  //                     .some(day => {
  //                         const slots = dates[day];

  //                         nextDate = slots.find(pickMatchedTimeSlots);

  //                         return nextDate;
  //                     });
  //             } else if (matchedDaysOfWeek.length) {
  //                 matchedDaysOfWeek
  //                     .some(day => {
  //                         const slots = dates[day];

  //                         nextDate = slots.find(slot => {
  //                             return getMoment(slot.date).isSameOrAfter(afterDate) && slot.date;
  //                         });

  //                         return nextDate;
  //                     });
  //             } else if (matchedTimesOfDay.length) {
  //                 matchedTimesOfDay
  //                     .some(day => {
  //                         const slots = dates[day];

  //                         nextDate = slots.find(pickMatchedTimeSlots);

  //                         return nextDate;
  //                     });
  //             }

  //             // Fallback
  //             if (!nextDate || (date && !date.isSame(nextDate.date, 'day'))) {
  //                 afterDate.startOf('day');

  //                 availableDates.some(day => {
  //                     const date = dates[day];

  //                     nextDate = date.find(v => {
  //                         const dateMoment = getMoment(v.date);
  //                         const nowMoment = getMoment();
  //                         return dateMoment.isSameOrAfter(afterDate) && (!dateMoment.isSame(nowMoment, 'day') || dateMoment.isSameOrAfter(nowMoment)) && v.date;
  //                     });

  //                     return nextDate;
  //                 });
  //             }

  //             if (nextDate) {
  //                 this.bookingTime.setDate(nextDate.date);
  //                 this.setState({ bookingTime: nextDate.date });
  //                 this.context.changeDirectBookingDateFilter({ directBookingDate: nextDate.date.getTime() });
  //             }
  //         },
  //     });

  //     // const finalMapStateToProps = (state, ownProps) => {
  //     //     if (typeof mapStateToProps !== 'function') {
  //     //         return { bookingDateTime: state.ui.filters.bookingDateTime };
  //     //     }

  //     //     return Object.assign({}, mapStateToProps(state, ownProps), { bookingDateTime: state.ui.filters.bookingDateTime });
  //     // }

  //     return hoistNonReactStatic(withRouter(connect(mapStateToProps, { updateBookingDateTime })(HOCComponent)), WrappedComponent);
  //     // return hoistNonReactStatic(HOCComponent, WrappedComponent);
  // }

  // return wrapComponent;
}

function dateOrNull(dt: any) {
  if (dt && !isNaN(dt.getTime())) {
    return dt;
  }

  return null;
}

function minDate(date1: Date, date2: Date, region: string) {
  // @ts-ignore
  const date = getMomentWithTz(new Date(Math.min(date1, date2)), region).toDate();

  return date;
}

function maxDate(date1: Date, date2: Date, region: string) {
  // @ts-ignore
  const date = getMomentWithTz(new Date(Math.max(date1, date2)), region).toDate();

  return date;
}

function clamp(date: Date, min: Date, max: Date, region: string): Date {
  // @ts-ignore
  return maxDate(minDate(date, max), min);
}

// Borrowed from MathUtils
//
// function constrain(amount: number, low: number, high: number) {
//   return amount < low ? low : (amount > high ? high : amount);
// }

// // Date picker
//    private AvailabilityDayPicker mDatePicker;

//    // Time picker
//    private AvailabilityTimePicker mTimePicker;

//      setOnClickListener(new View.OnClickListener() {
//            @Override
//            public void onClick(View v) {
//                mTimePickerGridView.setVisibility(View.INVISIBLE);
//                mSlidingUpPanelLayout.setPanelState(TBSlidingUpPanelLayout.PanelState.HIDDEN);
//            }
//        });

//        mAddAvailableTimeButton.setOnClickListener(new View.OnClickListener() {
//            @Override
//            public void onClick(View v) {
//                mSlidingUpPanelLayout.setPanelState(TBSlidingUpPanelLayout.PanelState.EXPANDED);
//            }
//        });

//        final ToggleButton allDayButton = findViewById(R.id.toggleButton);
//        final View timePickerExpandMoreImage = findViewById(R.id.timePickerExpandMoreImage);

//        timePickerExpandMoreImage.setOnClickListener(new View.OnClickListener() {
//            @Override
//            public void onClick(View v) {
//                mSlidingUpPanelLayout.setPanelState(TBSlidingUpPanelLayout.PanelState.HIDDEN);
//            }
//        });

// //
// export default function AvailabilityPicker() {

// }
